import InfoIconSvg from '@assets/icons/info.svg?react'
import { Box, type PlacementWithLogical, Tooltip } from '@chakra-ui/react'
import { type ReactNode, useState } from 'react'

export const InformationTooltip = ({
  label,
  color,
  placement,
  iconSize,
}: {
  label?: ReactNode
  color?: string
  placement?: PlacementWithLogical
  iconSize?: string | number
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(oldState => !oldState)
  }

  const handleMouseEnter = () => {
    setIsOpen(() => true)
  }

  const handleMouseLeave = () => {
    setIsOpen(() => false)
  }

  const props = {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    color: color,
  }

  return (
    <Tooltip
      placement={placement}
      isOpen={isOpen}
      label={label}
      bg='white'
      color='gray.800'
      fontWeight='normal'
      borderRadius='base'
      hasArrow
    >
      <Box {...props}>
        <InfoIconSvg width={iconSize ?? '16px'} height={iconSize ?? '16px'} />
      </Box>
    </Tooltip>
  )
}
